import mobileAdjustment from "../GeneralMobileAdjustments";

class MobilePrintButtonControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setButtonsHeight(element);
    }
}

const mobilePrintButtonControlView = new MobilePrintButtonControlView();
export default mobilePrintButtonControlView;